<template>
  <div style="width:100%;background:#fff;">
    <div style="text-ailgn:center;">
      <div class="cHeaderMain">
        <img src="@/assets/logo2.png" class="img" />
        <div>
          <div>
            <el-input
              placeholder="请输入搜索关键字"
              style="width:375px"
              v-model="value"
              @keyup.enter.native="toResult"
              class="input-with-select"
            >
              <el-button slot="append" icon="el-icon-search" @click="toResult"></el-button>
            </el-input>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Header",
  data() {
    return {
      value: "",
    };
  },
  methods: {
    toResult(){
      var routeData =  this.$router.resolve({
        name: "Search",
        query: {
          key: this.value,
        }
      });
      window.open(routeData.href, '_blank');
    }
  },
};
</script>

<style>
.cHeaderMain {
  width: 1200px;
  height: 94px;
  background: #fff;
  margin: 0 auto;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.cHeaderMain .img {
  width: 660px;
  height: 80px;
}
.cHeaderMain .el-input-group__append {
  background: #034f92;
  border-top-right-radius: 5px;
  border-bottom-right-radius: 5px;
  border: 1px solid #034f92;
  color: #fff;
}
.cHeaderMain .el-input__inner {
  border: 1px solid #034f92;
  border-top-left-radius: 5px;
  border-bottom-left-radius: 5px;
}
</style>
